var _rect, _rect2, _g, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrenchFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_3086)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    y: 0.728027,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_413_3086",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 29,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3.66675,
    y: 0.728027,
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_413_3086)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 0.728027,
    width: 9.33333,
    height: 20,
    fill: "#F44653"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.66675 20.728H5.66658V0.728027H-3.66675V20.728Z",
    fill: "#1035BB"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833252,
    y: 1.22803,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#ECEAE6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_3086"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    y: 0.728027,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrenchFlag);
export default __webpack_public_path__ + "static/media/french_flag.6b0d3e35b17a506e4ce8aa688738bdca.svg";
export { ForwardRef as ReactComponent };